// export const API_URL = 'http://localhost:8080'
export const API_URL = 'https://api-capgestion-v2.performance-adviser.com'
